<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <swatches
      v-model="vInitial"
      show-fallback
      fallbackOkClass="ant-btn ant-btn-primary"
      row-length="9"
      shapes="circles"
      show-border
      popover-to="left"
      class="zind"
      @input="handleValueChange"
    >
      <a-input
        slot="trigger"
        :size="size"
        class="form__input__element"
        v-decorator="[varName, {
                  rules: [{ required: varRequired, message: 'Please enter your color as hex', type:'string', pattern: new RegExp(/^#([0-9a-f]{6}|[0-9a-f]{3})$/i) }], initialValue: vInitial
                  }]"
        placeholder="Please enter hex color"
        @change="handleColorChange"
      >
        <a-icon slot="addonAfter" type="smile" theme="filled" :style="{color: vInitial}" />
      </a-input>
      <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
    </swatches>
  </a-form-item>
</template>

<script>
import Swatches from "vue-swatches";

import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  data() {
    return {
      vInitial: this.varInitial
    };
  },
  components: {
    Swatches
  },
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    description: [String, null]
  },
  methods: {
    handleColorChange(e) {
      this.vInitial = e.target.value;
    },
    handleValueChange(e){
      this.vInitial = e;
    }
  }
};
</script>

<style lang="css">
.vue-swatches__fallback__input--wrapper {
  display: table-cell;
  padding-right: 10px;
  width: 100%;
  font-size: 16px !important;
}
.vue-swatches__fallback__input {
  width: 100%;
  padding-top: 0.3px;
  padding-bottom: 0.3px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
  transition: all 0.3s;
}

.vue-swatches__fallback__button {
  padding: 6px 15px;
  color: #fff;
  background-color: #002e66 !important;
  border-radius: 5px;
  border-color: #002e66 !important;
  height: 40px;
  padding: 0 15px;
  font-size: 16px;
}
</style>
